import {
  Box,
  CircularProgress,
  Grid,
  Typography,
  Alert,
  Stack,
} from "@mui/material";
import { Description } from "@mui/icons-material";
import { CardView } from "./CardView";
import { FiltersQuestionnaire } from "./components/FilterQuestionnaire";
import { useQuestionnairesList } from "@/hooks/useQuestionnairesList";

interface QuestionnairesListProps {
  questionnaires: any[];
  loading: boolean;
  error?: string | null;
  onSelect: (questionnaire: any) => void;
  onViewHistory?: (questionnaire: any) => void;
  questionnaireResponses?: any[];
}

export function QuestionnairesList({
  questionnaires,
  loading,
  error,
  onSelect,
  onViewHistory,
  questionnaireResponses,
}: QuestionnairesListProps) {
  const {
    filteredQuestionnaires,
    hasQuestionnaireResponses,
    searchTerm,
    setSearchTerm,
    selectedStatus,
    setSelectedStatus,
    responseFilter,
    setResponseFilter,
    anchorEl,
    setAnchorEl,
    hasResponseInEncounter,
  } = useQuestionnairesList({
    questionnaires,
    questionnaireResponses,
  });

  return (
    <Stack width="100%">
      <FiltersQuestionnaire
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        selectedStatus={selectedStatus}
        setSelectedStatus={setSelectedStatus}
        anchorEl={anchorEl}
        setAnchorEl={(anchorEl: HTMLElement | null) =>
          setAnchorEl(anchorEl as HTMLButtonElement)
        }
        responseFilter={responseFilter}
        setResponseFilter={setResponseFilter}
      />

      {loading && (
        <Box display="flex" justifyContent="center" py={4}>
          <CircularProgress />
        </Box>
      )}

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      {!loading && !error && (
        <Grid container spacing={2} maxHeight="48vh" overflow="auto">
          {filteredQuestionnaires.length === 0 ? (
            <Grid item xs={12}>
              <Stack
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                py={6}
                textAlign="center"
              >
                <Description
                  sx={{ fontSize: 64, color: "text.secondary", mb: 2 }}
                />
                <Typography variant="h6" color="text.secondary" gutterBottom>
                  Nenhum questionário encontrado
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {searchTerm
                    ? "Tente ajustar os termos de busca"
                    : "Não há questionários disponíveis no momento"}
                </Typography>
              </Stack>
            </Grid>
          ) : (
            filteredQuestionnaires.map((questionnaire: any) => (
              <Grid item xs={12} md={6} key={questionnaire.id} lg={6}>
                <CardView
                  questionnaire={questionnaire}
                  onSelect={onSelect}
                  onViewHistory={onViewHistory}
                  hasResponses={hasQuestionnaireResponses(questionnaire.id)}
                  isRespondedInEncounter={hasResponseInEncounter(
                    questionnaire.id
                  )}
                />
              </Grid>
            ))
          )}
        </Grid>
      )}
    </Stack>
  );
}
